/**
 * Pack Builder Cart Module
 * — Handles cart operations, bundle updates, and cart-related utilities
 */

(function() {
    'use strict';

    if (typeof PackBuilder === 'undefined') {
        console.error('PackBuilder class must be defined before pack-builder-cart.js');
        return;
    }

    PackBuilder.prototype.setCheckoutButtonLoadingState = function(isLoading) {
        const checkoutBtn = this.addBundleBtn || document.querySelector('.pb-summary__add');
        if (!checkoutBtn) return;

        const checkoutText = checkoutBtn.querySelector('.pb-summary__add-checkout');
        const fillText = checkoutBtn.querySelector('.pb-summary__add-fill');
        const arrow = checkoutBtn.querySelector('.pb-summary__add-arrow');

        let loadingIcon = checkoutBtn.querySelector('.pb-summary__add-loading-icon');
        if (!loadingIcon) {
            loadingIcon = document.createElement('span');
            loadingIcon.className = 'pb-summary__add-loading-icon hidden';
            loadingIcon.setAttribute('aria-hidden', 'true');
            loadingIcon.style.cssText = [
                'display:inline-block',
                'width:14px',
                'height:14px',
                'border:2px solid currentColor',
                'border-right-color: transparent',
                'border-radius:50%',
                'animation: pb-summary-spin 0.8s linear infinite'
            ].join(';');
            checkoutBtn.appendChild(loadingIcon);
        }

        if (!document.getElementById('pb-summary-spin-style')) {
            const style = document.createElement('style');
            style.id = 'pb-summary-spin-style';
            style.textContent = '@keyframes pb-summary-spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }';
            document.head.appendChild(style);
        }

        if (isLoading) {
            checkoutBtn.setAttribute('aria-busy', 'true');
            checkoutBtn.setAttribute('disabled', 'disabled');
            if (fillText) fillText.classList.add('hidden');
            if (arrow) arrow.classList.add('hidden');
            if (checkoutText) {
                if (!checkoutText.dataset.defaultText) {
                    checkoutText.dataset.defaultText = checkoutText.textContent;
                }
                checkoutText.textContent = 'Adding to Cart';
                checkoutText.classList.remove('hidden');
            }
            loadingIcon.classList.remove('hidden');
            return;
        }
        setTimeout(() => {
            checkoutBtn.removeAttribute('aria-busy');
            if (checkoutText) {
                checkoutText.textContent = checkoutText.dataset.defaultText || 'Continue to Checkout';
            }
            checkoutBtn.setAttribute('aria-busy', 'false');
            checkoutBtn.removeAttribute('disabled');
            loadingIcon.classList.add('hidden');
        }, 2000)
    };

    /**
     * async addBundleToCart()
     * — Validates and constructs the dynamic bundle via Recharge, builds
     *   the cart.js payload (items + properties), includes ONE‑TIME add‑ons,
     *   then redirects to checkout.
     */
    PackBuilder.prototype.addBundleToCart = async function() {
        const _this = this;
        this.setCheckoutButtonLoadingState(true);

        try {
            // Clear the entire cart before adding new products
            try {
                await fetch(`${window.Shopify.routes.root}cart/clear.js`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    }
                });
            } catch (error) {
                console.log('cart clear error', error);
            }

            // If an existing bundle is in the cart, remove it first
            if (this.bundleInCart === 'true') {
                try {
                    await fetch(`${window.Shopify.routes.root}${this.bundleRemoveLink}`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        }
                    });
                } catch (error) {
                    console.log('cancel error', error);
                }
            }

            let selectionList = [];
            this.panelDrawer.classList.add('is-loading');

        // Build selection list from current non‑addon selections
        this.selections.forEach(function(selection, i) {
            let planId = 0

            if (_this.cupLimit == 9) {
                planId = selection.selling_plans.find(obj =>
                    (obj.freq_value === _this.sellingPlan.plan_value &&
                        obj.freq_unit === _this.sellingPlan.plan_unit && obj.plan_name?.includes('subscription - 3%'))
                )?.plan_id;
            }
            if (planId == 0 || planId == undefined) {
                planId = selection.selling_plans.find(obj =>
                    (obj.freq_value === _this.sellingPlan.plan_value &&
                        obj.freq_unit === _this.sellingPlan.plan_unit)
                ).plan_id;
            }

            const itemObj = {
                collectionId: String(selection.collection_id),
                externalProductId: String(selection.id),
                externalVariantId: String(selection.variant_id),
                quantity: Number(selection.quantity) || 1,
                sellingPlan: planId
            };

            _this.selectionProperties += `${selection.title} x ${selection.quantity}`;
            if (i < _this.selections.length - 1) {
                _this.selectionProperties += ', ';
            }

            selectionList.push(itemObj);
        });

        const bundleData = {
            productId: this.productId,
            variantId: this.variantId,
            sellingPlan: this.sellingPlan.plan_id,
            selections: selectionList,
            handle: this.container.getAttribute('data-product-handle')
        };

        const bundle = {
            externalVariantId: bundleData.variantId,
            externalProductId: bundleData.productId,
            selections: bundleData.selections
        };

            const isValid = await recharge.bundle.validateDynamicBundle(bundle);
            if (!isValid) {
                return;
            }

        // Core bundle items (subscription components) from Recharge helper
            let cartItems = await recharge.bundle.getDynamicBundleItems(bundle, bundleData.handle);

        // Tag each bundle component with pack size
            for (const item of cartItems) {
                item.properties = item.properties || {};
                item.properties['_Pack_Size'] = _this.cupLimit;
            }

        // --- append ONE‑TIME ADD‑ONS as normal Shopify line items -----------
        // Only include add-ons with qty > 0. Use Shopify numeric variant IDs.
            const addonLineItems = (this.subscriptionAddons || [])
                .filter(a => Number(a.quantity) > 0)
                .map(a => {
                    const vid = String(a.variant_id);
                    const numericVid = Number((vid.match(/\d+$/) || [vid])[0]); // handle gid or plain id
                    return {
                        id: numericVid,
                        quantity: Number(a.quantity) || 1,
                        // Optional properties (remove if you don't want to show in cart line item)
                        properties: {
                            '_One_Time_AddOn': 'true',
                            '_Pack_Size': _this.cupLimit
                        }
                    };
                });

        // Combine bundle items + one-time add-ons into a single /cart/add.js call
            const allItems = cartItems.concat(addonLineItems);

            const properties = {
                Selections: selectionList,
                _Pack_Size: _this.cupLimit,
                _deliveryDate: this.deliveryInfo.delivery_date
            };

            const data = {
                items: allItems,
                properties: properties // (Shopify ignores root properties when items[] is used; safe to keep)
            };

        // Send a POST request to add everything to the cart
            await fetch(`${window.Shopify.routes.root}cart/add.js`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(data)
            });

        // Set cart attributes for delivery/Nextime
            const attributes = {
                "_Nextime_Delivery_date": this.deliveryInfo.delivery_date,
                "_Nextime_Shipping_Method": this.deliveryInfo.shipping_method,
                "_Nextime_Shipping_Name": this.deliveryInfo.shipping_name,
                "_Nextime_Shipping_Total": this.deliveryInfo.shipping_total,
                "_Nextime_Ship_Date": this.deliveryInfo.ship_date,
                "_Nextime_Charge_Date": this.deliveryInfo.charge_date,
                "Pack Size": _this.cupLimit
            };

            await fetch("/cart/update.json", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                },
                body: JSON.stringify({
                    attributes
                })
            });

            this.setCheckoutButtonLoadingState(false);
            this.markPackCartSynced();
            await this.stampPackCartToken();
            window.location.href = '/checkout';
        } catch (error) {
            console.error('addBundleToCart error', error);
            this.setCheckoutButtonLoadingState(false);
        } finally {
            this.panelDrawer.classList.remove('is-loading');
        }
    };

    /**
     * async updateBundle()
     * — When editing an existing subscription bundle, gathers
     *   the updated selections and delivery data, calls Recharge
     *   updateBundle/updateSubscription/updateSubscriptionAddress
     *   as needed, then redirects back to /account.
     */
    PackBuilder.prototype.updateBundle = async function() {

        // Enter loading state
        this.panelDrawer.classList.add('is-loading');
        this.setCheckoutButtonLoadingState(true, 'Updating...');

        try {
            const subscriptionId = this.subscription.id;

            // 1) Build the core pack (cup items only)
            const coreSelections = (this.selections || []).filter(s => Number(s.cup_value) > 0);

            let selectionList = coreSelections.map(sel => ({
                collection_id: String(sel.external_collection_id),
                collection_source: 'shopify', // keep your existing key spelling
                external_product_id: String(sel.id),
                external_variant_id: String(sel.variant_id),
                quantity: Number(sel.quantity) || 1
            }));

            // 2) Preserve EXISTING RECURRING add-ons from the live bundle selection
            let preservedRecurring = [];
            try {
                // Prefer the selection you already loaded in init(); fallback to list->find
                const sel = this.subscriptionSelection?.id ?
                    await recharge.bundle.getBundleSelection(this.session, this.subscriptionSelection.id) :
                    (await recharge.bundle.listBundleSelections(this.session, {
                        limit: 250,
                        sort_by: 'id-asc'
                    }))
                    .bundle_selections.find(s => Number(s.purchase_item_id) === Number(subscriptionId));

                const existingItems = sel?.items || [];
                preservedRecurring = existingItems
                    .filter(i => String(i.collection_id) === String(this.addon_collection_id) && Number(i.quantity) > 0)
                    .map(i => ({
                        collection_id: String(i.collection_id),
                        collection_source: 'shopify',
                        external_product_id: String(i.external_product_id?.ecommerce ?? i.external_product_id),
                        external_variant_id: String(i.external_variant_id?.ecommerce ?? i.external_variant_id),
                        quantity: Number(i.quantity) || 1
                    }));
            } catch (e) {
                console.warn('Could not load current selection to preserve recurring add-ons:', e);
            }

            // 3) Merge core pack + preserved recurring add-ons
            selectionList = selectionList.concat(preservedRecurring);

            // 4) Update the bundle ONCE with the merged items
            const pidStr = String(this.productId).match(/(\d+)$/)?.[1] ?? String(this.productId);
            const vidStr = String(this.variantId).match(/(\d+)$/)?.[1] ?? String(this.variantId);

            const bundleData = {
                external_product_id: {
                    ecommerce: pidStr,
                    ecommerce_v2: `gid://shopify/Product/${pidStr}`
                },
                external_variant_id: {
                    ecommerce: vidStr,
                    ecommerce_v2: `gid://shopify/ProductVariant/${vidStr}`
                },
                items: selectionList
            };

            // 5-pack (cancel-flow save): persist the pack tier on the subscription so
            // /account and Edit Pack reopen it as a 5-pack. Merged onto the live
            // properties, because Recharge replaces the whole list on every write
            // (assets/subscription-properties.js, the Oct 2026 Nextime-route incident).
            // Returns null for every save that does not enter or leave a 5-pack.
            const tierProps = this.fivePackPropertiesForSave?.();
            if (tierProps) {
                bundleData.properties = await this.mergedSubscriptionProperties(subscriptionId, tierProps);
            }

            await recharge.bundle.updateBundle(this.session, subscriptionId, bundleData);

            // 5) Sync ONE-TIME add-ons (these are not part of the bundle)
            await this.syncOnetimeAddons();

            // 6) Address change (if any)
            const deliveryAddressId = Number(this.deliveryInfo.address_id);
            const subscriptionAddressId = Number(this.subscription.address_id);
            if (deliveryAddressId && deliveryAddressId !== subscriptionAddressId) {
                await recharge.subscription.updateSubscriptionAddress(this.session, subscriptionId, deliveryAddressId)
                    .catch(err => console.log('address update error', err));
            }

            // 7) Frequency change (if any). A longer interval also moves the upcoming
            //    charge so the new schedule starts with it (pack-builder-frequency.js);
            //    one-time add-ons on that charge move with it.
            const freqInterval = this.sellingPlan?.plan_value;
            const freqUnit = this.sellingPlan?.plan_unit;
            if (freqInterval && freqUnit &&
                (this.subscription.order_interval_frequency != freqInterval ||
                    this.subscription.order_interval_unit != freqUnit)) {
                const currentNextCharge = this.subscription.next_charge_scheduled_at;
                const nextCharge = await this.nextChargeForFrequency(freqInterval, freqUnit);
                const optionsObj = {
                    charge_interval_frequency: freqInterval,
                    order_interval_frequency: freqInterval,
                    order_interval_unit: freqUnit,
                    next_charge_scheduled_at: nextCharge,
                };
                const updatedSub = await recharge.subscription.updateSubscription(this.session, subscriptionId, optionsObj)
                    .catch(err => console.log('frequency update error', err));
                const landedOn = updatedSub?.next_charge_scheduled_at || null;
                if (landedOn && String(landedOn).slice(0, 10) !== String(currentNextCharge).slice(0, 10)) {
                    await this.moveOnetimeAddons(currentNextCharge, landedOn);
                }
            }

            this.saveEditPackSelectionsToStorage();

            // 5-pack save: the escalation offer carries the discount too (?offer=discount).
            if (this.fivePack) {
                if (this.fivePackOffer === 'discount') {
                    await this.applyFivePackDiscount(subscriptionId);
                }
                this.trackFivePackSave(subscriptionId);
            }

            // Done
            window.location.href = '/account';
        } catch (error) {
            console.error('updateBundle error', error);
            this.setCheckoutButtonLoadingState(false);
        } finally {
            this.panelDrawer.classList.remove('is-loading');
        }
    };

    /**
     * Scheduled date (YYYY-MM-DD) of this subscription's most recent order, or null.
     * init() starts it in edit mode; updateBundle() and the frequency note reuse it.
     */
    PackBuilder.prototype.loadLastChargeDate = function() {
        if (!this._lastChargeDatePromise) {
            const frequency = window.PackBuilderFrequency;
            const nextCharge = this.subscription?.next_charge_scheduled_at || null;
            this._lastChargeDatePromise = (!frequency || !this.subscription?.id) ?
                Promise.resolve(null) :
                recharge.charge.listCharges(this.session, {
                    purchase_item_id: this.subscription.id,
                    sort_by: 'scheduled_at-desc',
                    limit: 25
                })
                .then(res => frequency.lastProcessedChargeDate(res?.charges, nextCharge))
                .catch(err => {
                    console.warn('Could not load the last charge for this subscription:', err);
                    return null;
                });
        }
        return this._lastChargeDatePromise;
    };

    /**
     * The next charge date to save with a new frequency. Same as today unless the
     * customer is moving to a longer interval and the upcoming charge is still on
     * the old cadence — then it moves out whole weeks, so it stays on their
     * delivery-lane weekday. Falls back to the current date whenever unsure.
     */
    PackBuilder.prototype.nextChargeForFrequency = async function(freqInterval, freqUnit) {
        const current = this.subscription?.next_charge_scheduled_at || null;
        const frequency = window.PackBuilderFrequency;
        if (!current || !frequency) return current;

        const lastCharge = await this.loadLastChargeDate();
        return frequency.nextChargeDate({
            nextCharge: current,
            lastCharge: lastCharge,
            fromDays: frequency.intervalDays(this.subscription.order_interval_frequency, this.subscription.order_interval_unit),
            toDays: frequency.intervalDays(freqInterval, freqUnit)
        });
    };

    /**
     * Moves one-time add-ons from the old charge date to the new one so they still
     * ship with the pack instead of going out alone on the old date.
     */
    PackBuilder.prototype.moveOnetimeAddons = async function(fromDate, toDate) {
        const addressId = Number(
            this.subscription?.address_id ||
            this.subAddressID ||
            this.deliveryInfo?.address_id
        );
        const from = String(fromDate || '').slice(0, 10);
        const to = String(toDate || '').slice(0, 10);
        if (!addressId || !from || !to || from === to) return;

        try {
            const res = await recharge.onetime.listOnetimes(this.session, {
                address_id: addressId,
                limit: 250
            });
            for (const ot of (res?.onetimes || [])) {
                if (String(ot.next_charge_scheduled_at || '').slice(0, 10) !== from) continue;
                await recharge.onetime.updateOnetime(this.session, ot.id, {
                    next_charge_scheduled_at: to
                }).catch(err => console.warn('[frequency] could not move one-time add-on', ot.id, err));
            }
        } catch (e) {
            console.warn('[frequency] listOnetimes failed', e);
        }
    };

    /**
     * "Mon, Oct 12" for the delivery that a charge on `chargeDate` makes, using the
     * same weekday arithmetic as the account page's delivery cards. '' if unknown.
     */
    PackBuilder.prototype.deliveryDateForCharge = function(chargeDate) {
        const charge = String(chargeDate || '').slice(0, 10);
        const prop = (this.subscription?.properties || []).find(p => p.name === '_Nextime_Delivery_Date');
        const lane = String(prop?.value || '').split('T')[0];
        if (!/^\d{4}-\d{2}-\d{2}$/.test(charge) || !/^\d{4}-\d{2}-\d{2}$/.test(lane)) return '';

        const date = new Date(`${charge}T00:00:00Z`);
        const laneDay = new Date(`${lane}T00:00:00Z`).getUTCDay();
        date.setUTCDate(date.getUTCDate() + ((laneDay - date.getUTCDay() + 7) % 7));
        return date.toLocaleDateString('en-US', {
            weekday: 'short',
            month: 'short',
            day: 'numeric',
            timeZone: 'UTC'
        });
    };

    /**
     * Edit mode: before the customer saves a different frequency, say where their
     * next delivery lands (a longer interval now moves it; a shorter one does not).
     */
    PackBuilder.prototype.updateFrequencyNote = async function() {
        if (!this.hasSubscription || !this.subscription || !this.addBundleBtn) return;

        const token = (this._frequencyNoteToken || 0) + 1;
        this._frequencyNoteToken = token;

        const plan = this.sellingPlan || {};
        const changed = plan.plan_value && plan.plan_unit &&
            (Number(this.subscription.order_interval_frequency) !== Number(plan.plan_value) ||
                this.subscription.order_interval_unit !== plan.plan_unit);

        let text = '';
        if (changed) {
            const current = this.subscription.next_charge_scheduled_at;
            const next = await this.nextChargeForFrequency(plan.plan_value, plan.plan_unit);
            if (token !== this._frequencyNoteToken) return; // a newer pick already ran

            const moved = next && String(next).slice(0, 10) !== String(current).slice(0, 10);
            const delivery = this.deliveryDateForCharge(next);
            if (moved) {
                const weeks = Math.round((window.PackBuilderFrequency?.daysBetween(current, next) || 0) / 7);
                text = delivery ?
                    `Your next delivery moves to ${delivery}.` :
                    `Your next delivery moves back ${weeks === 1 ? 'a week' : `${weeks} weeks`}.`;
            } else if (delivery) {
                text = `Your next delivery stays ${delivery}.`;
            }
        }

        let note = this.addBundleBtn.parentElement?.querySelector('.pb-summary__frequency-note');
        if (!text) {
            if (note) {
                note.remove();
                this.adjustfooterHeight();
            }
            return;
        }
        if (!note) {
            note = document.createElement('p');
            note.className = 'pb-summary__frequency-note text-align-center';
            note.setAttribute('role', 'status');
            this.addBundleBtn.insertAdjacentElement('beforebegin', note);
        }
        note.textContent = text;
        this.adjustfooterHeight();
    };

    /**
     * The subscription's live properties with `updates` merged in (ours win on a
     * name clash, everything else kept). Re-reads the subscription right before the
     * write so a property Nextime stamped since page load is not dropped.
     */
    PackBuilder.prototype.mergedSubscriptionProperties = async function(subscriptionId, updates) {
        let existing = Array.isArray(this.subscription?.properties) ? this.subscription.properties : [];
        try {
            const fresh = await recharge.subscription.getSubscription(this.session, subscriptionId);
            if (fresh && Array.isArray(fresh.properties)) existing = fresh.properties;
        } catch (err) {
            console.warn('[PackBuilder] could not re-read subscription properties', err);
        }
        if (window.SubscriptionProperties && typeof window.SubscriptionProperties.merge === 'function') {
            return window.SubscriptionProperties.merge(existing, updates);
        }
        const names = new Set(updates.map((p) => p.name));
        return existing
            .filter((p) => p && p.name && !names.has(p.name))
            .concat(updates)
            .map((p) => ({ name: p.name, value: p.value }));
    };

    /**
     * 5-pack save with the discount: apply the theme's 5-pack save code to the
     * subscription's address. Skipped when the address already carries a discount
     * (the cancel flow may have applied its own, and an address holds one code).
     */
    PackBuilder.prototype.applyFivePackDiscount = async function(subscriptionId) {
        const code = this.fivePackDiscountCode?.();
        const addressId = this.subscription?.address_id;
        if (!code || !addressId) return;
        try {
            const address = await recharge.address.getAddress(this.session, addressId);
            if (Array.isArray(address?.discounts) && address.discounts.length > 0) {
                console.info('[PackBuilder] 5-pack: address already has a discount, not applying', code);
                return;
            }
            await recharge.address.applyDiscountToAddress(this.session, addressId, code);
        } catch (err) {
            console.warn('[PackBuilder] 5-pack discount not applied', err);
        }
    };

    /** Analytics must never break the save. */
    PackBuilder.prototype.trackFivePackSave = function(subscriptionId) {
        try {
            window.gbEvents = window.gbEvents || [];
            window.gbEvents.push({
                eventName: 'five_pack_save',
                properties: {
                    subscription_id: String(subscriptionId || ''),
                    offer: String(this.fivePackOffer || 'none'),
                },
            });
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ event: 'five_pack_save', offer: String(this.fivePackOffer || 'none') });
        } catch (err) {
            /* ignore */
        }
    };

    /**
     * Saves current selections from edit pack to pack-specific storage.
     * This is called when updating a bundle to keep pack storage in sync
     */
    PackBuilder.prototype.saveEditPackSelectionsToStorage = function() {
        if (!this.hasSubscription) {
            return;
        }

        const packSelections = [];

        for (const selection of this.selections) {
            if (selection.cup_value > 0) {
                const quantity = Number(selection.quantity) || 1;
                for (let i = 0; i < quantity; i++) {
                    packSelections.push({
                        'title': selection.title || '',
                        'external_variant_id': selection.variant_id,
                        'external_product_id': selection.id,
                        'cup_value': selection.cup_value,
                    });
                }
            }
        }
        if (packSelections.length >= 0) {
            const firstSix = this.getFirstSixProducts(packSelections);
            const allNine = this.getSelectionsUpToCupLimit([...packSelections], 9);
            this.savePackSelections(6, firstSix);
            this.savePackSelections(9, allNine);
            // 5-pack mode reads its own storage: keep it in step too, or
            // handleUnsyncedSelections() sees storage ahead of the grid after a
            // removal and rebuilds the cup the subscriber just took out.
            if (this.fivePack) {
                this.savePackSelections(5, this.getFivePackSelections(packSelections));
            }
        }
    };

    /**
     * Fetches cart data from Shopify Cart API
     */
    PackBuilder.prototype.getCartJson = async function() {
        const res = await fetch('/cart.js', {
            credentials: 'same-origin'
        });
        if (!res.ok) throw new Error('Failed to fetch cart.js');
        return res.json();
    };

    /**
     * Get all salad pack products from Cart API
     * @param {Object} cart - cart data
     */
    PackBuilder.prototype.buildSelectionsFromCart = function(cart) {
        if (!cart || !Array.isArray(cart.items)) return [];

        const selections = [];

        cart.items.forEach(item => {
            const isFromPack =
                item.properties &&
                item.properties._rc_bundle_parent === 'salad-pack-builder';

            if (!isFromPack) return;

            let cupValue = 1;
            const productId = Number(item.product_id);
            
            if (this.productList && this.productList[productId]) {
                cupValue = this.productList[productId].cup_value || 1;
            } else if (item.sku && item.sku.includes('12oz')) {
                cupValue = 0.5;
            }

            const entry = {
                title: item.title,
                external_variant_id: item.variant_id,
                external_product_id: productId,
                cup_value: cupValue
            };

            // expand by quantity so duplicates appear as separate rows
            const qty = Math.max(1, Number(item.quantity) || 1);
            for (let i = 0; i < qty; i++) {
                selections.push({
                    ...entry
                });
            }
        });

        return selections;
    };

    /**
     * Ensures `pack-builder-selections` exists in localStorage as a stringified array.
     * If it already exists and has items, it is left as is.
     * If missing or empty, it creates it from the current cart.
     * Returns the final array.
     */
    PackBuilder.prototype.ensurePackBuilderSelections = async function() {
        // First check for pack-specific storage (preferred)
        const packSize = this.cupLimit || 6;
        const packSelections = this.getPackSelections(packSize);
        if (packSelections && packSelections.length > 0) {
            return packSelections;
        }
        
        // Fall back to old storage format for migration
        const raw = window.localStorage.getItem('pack-builder-selections');
        if (raw) {
            try {
                const parsed = JSON.parse(raw);
                if (Array.isArray(parsed) && parsed.length > 0) {
                    // Migrate to pack-specific storage
                    const firstSix = this.getFirstSixProducts(parsed);
                    const allNine = this.getSelectionsUpToCupLimit([...parsed], 9);
                    this.savePackSelections(6, firstSix);
                    this.savePackSelections(9, allNine);
                    window.localStorage.removeItem('pack-builder-selections');
                    return packSize === 6 ? firstSix : allNine;
                }
            } catch {
                // fall through to rebuild
            }
        }

        // If still empty, rebuild from cart
        try {
            const cart = await this.getCartJson();
            const selections = this.buildSelectionsFromCart(cart);
            if (selections && selections.length > 0) {
                const firstSix = this.getFirstSixProducts(selections);
                const allNine = this.getSelectionsUpToCupLimit([...selections], 9);
                this.savePackSelections(6, firstSix);
                this.savePackSelections(9, allNine);
                return packSize === 6 ? firstSix : allNine;
            }
        } catch (e) {
            console.warn('ensurePackBuilderSelections: failed to load from cart', e);
        }

        return [];
    };

})();
